var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"title"},[_c('li',{staticClass:"item left"}),_c('li',{staticClass:"center"},[_vm._t("default",function(){return [_vm._v("APP简介")]})],2),_c('li',{staticClass:"item right"})])}
var staticRenderFns = []

export { render, staticRenderFns }